import type { IGetSizeAndClassName } from 'components/common/form-drawer/helpers/types';
import { EFormDrawerSize } from 'components/common/form-drawer/types';
import styles from '../form-drawer.module.scss';

export const getSizeAndClassName = (size: EFormDrawerSize): IGetSizeAndClassName => {
  switch (size) {
    case EFormDrawerSize.LARGE:
      return { drawerSize: 'large', className: styles.bigDrawer };
    case EFormDrawerSize.MIDDLE:
      return { drawerSize: 'large' };
    case EFormDrawerSize.DEFAULT:
      return { drawerSize: 'default' };
  }
};
